import { sumBy } from "lodash";

import {
  OrganizationSubscriptionDto,
  SubscriptionDto,
} from "@intelligems/ig-types";

export const maybeAddOldPlans = (
  currentPlans: SubscriptionDto[],
  oldPlans: SubscriptionDto[],
  activeSubscriptions: OrganizationSubscriptionDto[]
) => {
  const plans = [...currentPlans];
  for (const oldPlan of oldPlans) {
    const hasOldPlan = activeSubscriptions.some(
      (sub) => sub.subscriptionId === oldPlan.id
    );
    if (hasOldPlan) {
      return [...currentPlans, oldPlan];
    }
  }
  return plans;
};

export const getIsSubscribedToBundle = (
  activeSubscriptions: OrganizationSubscriptionDto[],
  availableSubscriptions: SubscriptionDto[]
) => {
  let hasCampaigns = false;
  let hasPricing = false;
  let hasContent = false;

  for (const orgSub of activeSubscriptions) {
    const sub = availableSubscriptions.find(
      (sub) => sub.id === orgSub.subscriptionId
    );
    if (sub) {
      if (sub.name.includes("CAMPAIGNS")) {
        hasCampaigns = true;
      }
      if (sub.name.includes("PRICING")) {
        hasPricing = true;
      }
      if (sub.name.includes("CONTENT")) {
        hasContent = true;
      }
    }
  }

  return hasCampaigns && hasPricing && hasContent;
};

export const createBundle = (
  activeSubscriptions: OrganizationSubscriptionDto[],
  availableSubscriptions: SubscriptionDto[]
): SubscriptionDto | null => {
  const isSubscribedToBundle = getIsSubscribedToBundle(
    activeSubscriptions,
    availableSubscriptions
  );

  if (!isSubscribedToBundle) {
    return null;
  }

  const defaultPrice = Math.ceil(
    sumBy(
      availableSubscriptions.filter(
        (sub) =>
          !sub.name.includes("ADDON") &&
          !sub.name.includes("SHIPPING") &&
          !sub.name.includes("BASIC") &&
          sub.version === "2023-01"
      ),
      (_) => _.defaultPrice
    )
  );

  let currentPrice;
  if (isSubscribedToBundle) {
    currentPrice = Math.ceil(
      sumBy(activeSubscriptions, (_) => _.subscriptionPriceUsd)
    );
  } else {
    currentPrice = Math.ceil(
      sumBy(
        availableSubscriptions.filter(
          (sub) =>
            !sub.name.includes("ADDON") &&
            !sub.name.includes("SHIPPING") &&
            !sub.name.includes("BASIC")
        ),
        (_) => _.defaultPrice
      ) * 0.8
    );
  }

  return {
    id: "bundle",
    defaultPrice,
    isCurrent: false,
    isActive: false,
    webUiScopes: {},
    isDefault: false,
    defaultInterval: "monthly",
    altHeader: "Most Popular",
    name: "Bundle all 3",
    version: "2023-01",
    title: "Grandfathered Bundle Offer",
    description:
      "Easily test experiences, prices, themes, redirects, and shipping fees.",
  };
};
